import { handleActions, combineActions } from 'redux-actions';
import { LOAD_SESSION, LOGOUT, UPDATE_TOKEN } from '../constants';

const intialState = {
  loading: false,
  hasLoadedOnce: false,
  model: null,
  error: false,
};

const sessionReducer = handleActions(
  {
    [LOAD_SESSION.PENDING]: state => ({
      ...state,
      loading: true,
      error: false,
    }),
    [combineActions(
      LOAD_SESSION.CANCELLED,
      LOAD_SESSION.SUCCESS,
      LOAD_SESSION.ERROR,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_SESSION.SUCCESS]: (state, { payload }) => ({
      ...state,
      model: payload || state.model,
      hasLoadedOnce: true,
      error: false,
    }),
    [LOAD_SESSION.ERROR]: state => ({
      ...state,
      error: true,
    }),
    [LOGOUT.ACTION]: () => intialState,
  },
  intialState,
);

export default sessionReducer;
